import { render, staticRenderFns } from "./ConnectivityChip.vue?vue&type=template&id=18fcb56a"
import script from "./ConnectivityChip.vue?vue&type=script&lang=js"
export * from "./ConnectivityChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports